import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import { configureStore } from "./redux/store";
import { ChakraProvider } from '@chakra-ui/react'



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore()}>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </Provider>
);

// reportWebVitals();
